import { render, staticRenderFns } from "./matrix-status-badge.vue?vue&type=template&id=82a6971c"
import script from "./matrix-status-badge.vue?vue&type=script&lang=ts"
export * from "./matrix-status-badge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports